export default __webpack_public_path__ + "static/media/rate_active_icon.edea83ea.svg";